import React from 'react';
import PropTypes from 'prop-types';
import RpTable from 'rp-react-table';
import columns from './columns';

const RelativesTable = ({ data, title, noDataText }) => (
    <section className="hp-relatives">
        <h2 className="hp-relatives__title">{title}</h2>
        <RpTable
            columns={columns}
            data={data}
            initialSortIdx={8}
            noDataText={noDataText}
            sortable
        />
    </section>
);

RelativesTable.propTypes = {
    data: PropTypes.arrayOf(PropTypes.shape({
        avgFlatWinDistOfProgeny: PropTypes.number,
        countryOriginCode: PropTypes.string,
        horseName: PropTypes.string,
        horseSexCode: PropTypes.string,
        horseUid: PropTypes.number,
        horseYob: PropTypes.number,
        sireStyleName: PropTypes.string,
        sireCountryOriginCode: PropTypes.string,
        sireUid: PropTypes.number,
        stakesWinnerOrPlaced: PropTypes.bool,
        wins: PropTypes.number,
        runs: PropTypes.number,
        winPercent: PropTypes.number,
        places: PropTypes.number,
        trainerUid: PropTypes.number,
        trainerName: PropTypes.string,
        totalPrizeMoney: PropTypes.number,
        distanceYard: PropTypes.number,
        bestRpPostmark: PropTypes.number,
    })),
    noDataText: PropTypes.string,
    title: PropTypes.string,
};

export default RelativesTable;



// WEBPACK FOOTER //
// ./src/js/horse/pedigree/relativesTable/RelativesTable.jsx